import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { CreateInvitationsDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createInvitation = async ({
  data,
  organisationId,
}: {
  data: CreateInvitationsDto;
  organisationId: string;
}): Promise<{ id: number }> => {
  const response = await axiosClient.post(`/${organisationId}/invitations`, {
    ...data,
    emails: data.emails.map((email) => email.toLowerCase().trim()),
  });
  return response.data;
};

function useCreateInvitation(
  mutationOptions?: UseMutationOptions<
    { id: number },
    HttpError,
    { data: CreateInvitationsDto; organisationId: string }
  >,
) {
  return useMutation({
    mutationFn: ({
      data,
      organisationId,
    }: {
      data: CreateInvitationsDto;
      organisationId: string;
    }) => createInvitation({ data, organisationId }),
    ...mutationOptions,
  });
}

export { useCreateInvitation };
